import { render } from "./FormdataUpload.vue?vue&type=template&id=be0b6ce8&scoped=true"
import script from "./FormdataUpload.vue?vue&type=script&lang=js"
export * from "./FormdataUpload.vue?vue&type=script&lang=js"

import "./FormdataUpload.vue?vue&type=style&index=0&id=be0b6ce8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be0b6ce8"]])

export default __exports__